/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const oil_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13 20h5.596M13 15.5h7.464M13 11h6.707M13 6.5h3.688m0 0a283.871 283.871 0 0 1 2.038 2.81 9.16 9.16 0 0 1 1.774 5.418c0 .26-.012.517-.036.772m0 0a8.251 8.251 0 0 1-1.868 4.5M16.688 6.5C14.917 4.089 12.583 1 12.253 1c-.542 0-6.479 8.31-6.479 8.31A9.16 9.16 0 0 0 4 14.727 8.25 8.25 0 0 0 18.596 20"
    />
  </svg>
)
export default oil_medium
